import React, {
    useContext,
    useState
} from "react";

import cn from "classnames"

import { AUTH_FLOW_COMPONENTS, AuthContext } from "../contexts/Auth";

import as from "../styles/auth-styles.module.scss"

import PasswordVisibilityIcon from "./icons/PasswordVisibilityIcon"

const LoginForm = () => {

    const [passwordVisible, setPasswordVisible] = useState(false)

    const {
        authMsg,
        loginError,
        loginUserWithEmailAndPassword,
        setCurrAuthComponent
    } = useContext(AuthContext);


    // const haveMessage = () => "" !== loginError

    const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible)


    const handleForgotPassword = (event) => {
        event.preventDefault()
        setCurrAuthComponent(AUTH_FLOW_COMPONENTS.FORGOT_PASSWD)
    }

    const handleLogin = (event) => {
        event.preventDefault();
        const { email, password } = event.target.elements;
        loginUserWithEmailAndPassword(email.value, password.value)
    }

    const handleRegister = (event) => {
        event.preventDefault()
        setCurrAuthComponent(AUTH_FLOW_COMPONENTS.REGISTER)
    }

    return (
        <div>
            <form onSubmit={handleLogin}>
                <div className={as.container}>
                    <div className={as.row}>
                        <h3>Sign In</h3>
                    </div>

                    <div className={as.row}>
                        <label
                            htmlFor="email"
                            className={cn(as['col-sm-2'], as['col-form-label'])}
                        >
                            Email address
                        </label>
                        <div className={as['col-sm-10']}>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                className={as['form-control']}
                                placeholder="Enter email"
                                required
                            />
                        </div>
                    </div>

                    <div className={as.row}>
                        <label
                            htmlFor="password"
                            className={cn(as['col-sm-2'], as['col-form-label'])}
                        >
                            Password
                        </label>
                        <div className={cn(as['col-sm-10'], as['input-group'])}>
                            <input
                                id="password"
                                name="password"
                                type={passwordVisible ? "text" : "password"}
                                className={as['form-control']}
                                placeholder="Enter password"
                                required
                            />
                            <PasswordVisibilityIcon
                                visible={passwordVisible}
                                stateToggler={togglePasswordVisibility}
                            />
                        </div>
                    </div>
                    <div className={as.row}>
                        <p className={as['text-danger']}>
                            {loginError}
                        </p>
                    </div>
                    <div className={as.row}>
                        <p>{authMsg}</p>
                    </div>
                    <button
                        type="submit"
                        className={cn(as.btn, as['btn-primary'])}
                    >
                        Sign In
                    </button>
                    <button
                        type="button"
                        className={cn(as.btn, as['btn-link'])}
                        onClick={handleForgotPassword}
                    >
                        I forgot my Password
                    </button>
                    <button
                        type="button"
                        className={cn(as.btn, as['btn-link'])}
                        onClick={handleRegister}
                    >
                        Register
                    </button>
                </div>
            </form>
        </div>

    )
}

export default LoginForm;
